import styled from "@emotion/styled";

export const Wrapper = styled.div`
  aspect-ratio: var(--Media-aspect-ratio, 16 / 9);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--color-base-neutral80);
`;

export const PlayerWrapper = styled.div`
  background-color: var(--color-base-neutral100);
`;
